// Подписи таблиц (mui-datatables) по-русски: по умолчанию библиотека пишет по-английски
// («Rows per page», «Sorry, no matching records found», «FILTERS», «RESET»).
export const tableTextLabels = {
  body: {
    noMatch: "Ничего не найдено",
    toolTip: "Сортировать",
    columnHeaderTooltip: (column) => `Сортировать по «${column.label}»`,
  },
  pagination: {
    next: "Следующая страница",
    previous: "Предыдущая страница",
    rowsPerPage: "Строк на странице:",
    displayRows: "из",
  },
  toolbar: {
    search: "Поиск",
    downloadCsv: "Скачать CSV",
    print: "Печать",
    viewColumns: "Показать столбцы",
    filterTable: "Фильтр",
  },
  filter: {
    all: "Все",
    title: "ФИЛЬТРЫ",
    reset: "СБРОСИТЬ",
  },
  viewColumns: {
    title: "Показать столбцы",
    titleAria: "Показать или скрыть столбцы таблицы",
  },
  selectedRows: {
    text: "выбрано",
    delete: "Удалить",
    deleteAria: "Удалить выбранные строки",
  },
};
